import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_CURRENT_USER = "GET_CURRENT_USER";

export const service = async (data) => {
  const options: object = {
    url: `/Api/User/GetCurrentUser`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CURRENT_USER, service, mock);
